import callApi from "helpers/callApi";

async function readJson(response) {
  const text = await response.text();
  return text ? JSON.parse(text) : null;
}

async function requestSandbox(endpoint, method = "GET", payload, omitBody = false) {
  const response = await callApi(
    endpoint,
    method,
    payload ?? {},
    omitBody ? { omitBody: true } : undefined,
  );

  if (!response.ok) {
    throw new Error(response.errorMessage || "Error");
  }

  return readJson(response);
}

export function getSandboxInfoApi() {
  return requestSandbox("/sandbox/");
}

export function createSandboxApi(payload) {
  return requestSandbox("/sandbox/create", "POST", payload);
}

export function deleteSandboxApi() {
  return requestSandbox("/sandbox/delete", "DELETE", undefined, true);
}

export function switchToSandboxApi() {
  return requestSandbox("/sandbox/switch", "POST", undefined, true);
}

export function switchBackFromSandboxApi() {
  return requestSandbox("/sandbox/switch-back", "POST", undefined, true);
}
